import { Box } from "@mui/material";
import AboutMe from "./components/AboutMe";
import Introduction from "./components/Introduction";
import ContactMe from "./components/ContactMe";
import Experience from "./components/Experience";
import Projects from "./components/Projects";

export const Home: React.FC = () => {
  return (
    <>
      <Introduction id='introduction' />
      <AboutMe id='about-me' />
      <Experience id='experience' />
      <Projects id='projects' />
      <ContactMe id='contact-me' />
    </>
  );
};

export default Home;
